import { isUrl } from '../../../../shared';

const EXTRACT_LINKS_SEPARATOR = ';';

const isBlankExtractLink = (link: string) => !link.trim().replace(/^https?:\/\//i, '');

export const parseExtractLinks = (extractLink?: string) =>
  (extractLink ?? '')
    .split(EXTRACT_LINKS_SEPARATOR)
    .map((link) => link.trim())
    .filter(Boolean);

export const serializeExtractLinks = (links: string[]) =>
  links
    .filter((link) => !isBlankExtractLink(link))
    .map((link) => link.trim())
    .join(EXTRACT_LINKS_SEPARATOR);

export const getInvalidExtractLinkIndexes = (links: string[]) =>
  links.reduce<number[]>((invalidIndexes, link, index) => {
    const trimmedLink = link.trim();

    if (isBlankExtractLink(trimmedLink) && index > 0) {
      return invalidIndexes;
    }

    if (isUrl(trimmedLink) && !trimmedLink.includes(EXTRACT_LINKS_SEPARATOR)) {
      return invalidIndexes;
    }

    return [...invalidIndexes, index];
  }, []);
